import React, { useEffect, useState } from 'react'
import Select from "react-select";

import Breadcrumb from '../Breadcrumb/Breadcrumb';
import { downloadExcel1, getPermissionDetails, stringLimit } from '../../util/fn';
import useRequest from '../../hooks/useRequest';
import axios from 'axios';
import { BASEURL } from '../../constant/api';
import { toast } from 'react-toastify';
import LineGraph from './LineGraph';
import BarChart from './BarChart';

function Growth() {
  const { request: requestCities, response: responseCities } = useRequest();
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState('');
  const [Dates, setDates] = useState([]);
  const [Dates1, setDates1] = useState([]);
  const [Dates2, setDates2] = useState([]);
  const [area, setArea] = useState('');
  const [seriesData, setSeriesData] = useState([{ name: "Growth", data: [''] }]);
  const [seriesData1, setSeriesData1] = useState([{ name: "Growth", data: [''] }]);
  const [seriesData2, setSeriesData2] = useState([{ name: "Growth", data: [''] }]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const { request: request, response: response } = useRequest();
  const [permissions, setPermissions] = useState([])
  const [data, setData] = useState('')
  const perPage = 10;
  const [totalDocuments, setTotalDocuments] = useState(10);
  const [page, setPage] = useState(1);

  const [startIndex, setStartIndex] = useState(1);

  useEffect(() => {
    requestCities("GET", "admin/vendor/getCity");
  }, []);

  useEffect(() => {
    const todayDate = new Date();
    todayDate.setDate(todayDate.getDate() - 15);
    setStartDate(todayDate.toISOString().split('T')[0]);

    todayDate.setDate(todayDate.getDate() + 15);
    setEndDate(todayDate.toISOString().split('T')[0]);
  }, [])
  useEffect(() => {

    GetData()
  }, [startDate, endDate]);
  useEffect(() => {
    if (responseCities) {
      if (responseCities.status && responseCities.data) {
        setCities(responseCities.data);

      }
    }
  }, [responseCities]);

  const DownloadExcel = async () => {



    const data = {
      city: city,
      area: area,
      startDate: startDate,
      endDate: endDate,
      isExcelDownload:true

    }
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + localStorage.getItem("token")
      }
    };

    try {
      const response = await axios.post(`${BASEURL.PORT}/admin/report/revenueGrowthReport`, data, config);
      if (response?.data?.status == true) {
        let period = response?.data?.data?.cityRevenue?.map((obj, index) => ({
          'Sr.': index + 1,
          'Date': obj?.date,
          'Revenue': obj?.revenue,
    
        }));
        let monthly = response?.data?.data?.monthlyRevenue?.map((obj, index) => ({
          'Sr.': index + 1,
          'Date': obj?.date,
          'Revenue': obj?.revenue,
    
        }));
    
        let yearly = response?.data?.data?.yearlyRevenueArray?.map((obj, index) => ({
          'Sr.': index + 1,
          'Month': obj?.month,
          'Revenue': obj?.revenue,
    
        }));
    
    
    
        const dataArray = [period, monthly, yearly];
        const namesArray = ["Period Revenue Report", 'Monthly Growth Report', 'Yearly Growth Report'];
        const headingsArray = [null, null]; // Assuming no headers for the data
    
        downloadExcel1(dataArray, namesArray, headingsArray);

      }

    } catch (error) {
      toast.error(error.message)
    }

  }

  const GetData = async () => {
    const data = {
      city: city,
      area: area,
      startDate: startDate,
      endDate: endDate
    }
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + localStorage.getItem("token")
      }
    };

    try {
      const response = await axios.post(`${BASEURL.PORT}/admin/report/revenueGrowthReport`, data, config);
      if (response?.data?.status == true) {
        setData(response?.data?.data)
        const dataa = response?.data?.data?.cityRevenue?.map((val) => (
          parseInt(val.revenue)
        ))

        const dataa1 = response?.data?.data?.monthlyRevenue?.map((val) => (
          parseInt(val.revenue)
        ))
        const dataa2 = response?.data?.data?.yearlyRevenueArray?.map((val) => (
          parseInt(val.revenue)
        ))
        setDates(response?.data?.data?.cityRevenue?.map((val) => (
          val.date
        )))
        setDates1(response?.data?.data?.monthlyRevenue?.map((val) => (
          val.date
        )))
        setDates2(response?.data?.data?.yearlyRevenueArray?.map((val) => (
          val.month
        )))


        setSeriesData(
          { name: "City Wise Revenue", data: [...dataa] }
        );
        setSeriesData1(
          { name: "Month Wise Revenue", data: [...dataa1] }
        )
        setSeriesData2(
          { name: "Yearly Wise Revenue", data: [...dataa2] }
        )

      }

    } catch (error) {
      toast.error(error.message)
    }
  }





  return (
    <div>

      <div className="ms-content-wrapper">
        <div className="row">
          <div className="col-md-12">
            <Breadcrumb
              title={"Revenue Report"}
              links={[{ to: "/", name: "Home" }]}
            />
            <div className="ms-panel">
              <div className="ms-panel-header">
                <div className="row">
                  <div className="col-md-3">
                    <h6>{"Revenue Report"}</h6>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-2">
                    <div className="form-group">
                      <label htmlFor="cities">From Date:</label>
                      <input type='date'
                        value={startDate}
                        className='form-control'

                        onChange={(e) => {
                          // Calculate end date as 15 days from the start date
                          const endDate = new Date(e.target.value);
                          endDate.setDate(endDate.getDate() + 15);
                          setEndDate(endDate.toISOString().split('T')[0]);
                          setStartDate(e.target.value)
                        }
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-2">

                    <div className="form-group">
                      <label htmlFor="cities">To Date:</label>
                      <input type='date'
                        className='form-control'
                        value={endDate}
                        disabled
                        onChange={(e) => setEndDate(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label htmlFor="cities">Area:</label>
                      <input type='text'
                        className='form-control'
                        value={area}

                        onChange={(e) => setArea(e.target.value)} />
                    </div>
                  </div>

                  <div className="col-md-2">

                    <div className="form-group">
                      <label htmlFor="cities">City:</label>
                      <Select
                        options={
                          cities &&
                          cities.length > 0 &&
                          cities.map((obj) => ({
                            label: obj.name,
                            value: obj._id,
                          }))
                        }
                        name="cities"
                        onChange={(value) => {
                          setCity(value.value)
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className='d-flex'>
                      <button className="mx-3 btn btn-primary burron" onClick={DownloadExcel}>Download Excel</button>
                      <button className="mx-3 btn btn-primary burron" onClick={GetData}>Filter</button>
                    </div>

                  </div>
                </div>



              </div>


              <div className='row'>
                <div className='col-md-4'></div>
                <div className='col-md-6'>
                  <div className='mt-5'><h5>Revenue Growth (Period)</h5></div>
                </div>
              </div>


              <div className="row">
                <div className='col-md-6'>
                  <div className="ms-panel-body">
                    <div className="table-responsive">
                      <table className="table table-hover thead-primary">
                        <thead>
                          <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Revenue</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            data?.cityRevenue?.length > 0 &&
                            data?.cityRevenue?.map((item, i) => (
                              <tr key={item._id}>

                                <td>{item.date}</td>
                                <td>{item.revenue
                                }</td>

                              </tr>
                            ))}
                          {data?.cityRevenue?.length == 0 && (
                            <tr>
                              <td colspan="10" style={{ textAlign: "center" }}>
                                {" "}
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <LineGraph title='Revenue Growth (Period)' series={seriesData} categories={Dates} />
                </div>
              </div>

              <div className='row mt-2'>
                <div className='col-md-4'></div>
                <div className='col-md-6'>
                  <div className='mt-5'><h5>Revenue Growth (Monthly)</h5></div>
                </div>
              </div>


              <div className="row">
                <div className='col-md-6'>
                  <div className="ms-panel-body">
                    <div className="table-responsive">
                      <table className="table table-hover thead-primary">
                        <thead>
                          <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Revenue</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            data?.monthlyRevenue?.length > 0 &&
                            data?.monthlyRevenue?.map((item, i) => (
                              <tr key={item._id}>

                                <td>{item.date}</td>
                                <td>{item.revenue
                                }</td>

                              </tr>
                            ))}
                          {data?.monthlyRevenue?.length == 0 && (
                            <tr>
                              <td colspan="10" style={{ textAlign: "center" }}>
                                {" "}
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <LineGraph title='Revenue Growth (Monhtly)' series={seriesData1} categories={Dates1} />
                </div>
              </div>

              <div className='row mt-2'>
                <div className='col-md-4'></div>
                <div className='col-md-6'>
                  <div className='mt-5'><h5>Revenue Growth (Yearly)</h5></div>
                </div>
              </div>


              <div className="row">
                <div className='col-md-6'>
                  <div className="ms-panel-body">
                    <div className="table-responsive">
                      <table className="table table-hover thead-primary">
                        <thead>
                          <tr>
                            <th scope="col">Month</th>
                            <th scope="col">Revenue</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            data?.yearlyRevenueArray?.length > 0 &&
                            data?.yearlyRevenueArray?.map((item, i) => (
                              <tr key={item._id}>

                                <td>{item.month}</td>
                                <td>{item.revenue
                                }</td>

                              </tr>
                            ))}
                          {data?.yearlyRevenueArray?.length == 0 && (
                            <tr>
                              <td colspan="10" style={{ textAlign: "center" }}>
                                {" "}
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <LineGraph title='Revenue Growth (Yearly)' series={seriesData2} categories={Dates2} />
                </div>
              </div>

            </div>

          </div>
          {/* <div className="col-md-12">
            {perPage !== 0 &&
              data.length != totalDocuments &&
              data.length != 0 && (
                <Pagination
                  page={page}
                  totalDocuments={totalDocuments}
                  getNewData={fetchMoreData}
                  perPage={perPage}
                  currentDocLength={data.length}
                />
              )}
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default Growth